export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'institutions',
      displayName: 'menu.institutions',
      meta: {
        icon: 'business',
      },
    },
    {
      name: 'usage',
      displayName: 'menu.usage',
      meta: {
        icon: 'analytics',
      },
      children: [
        {
          name: 'usage-overview',
          displayName: 'menu.usage-overview',
        },
        {
          name: 'usage-by-institution',
          displayName: 'menu.usage-by-institution',
        },
      ],
    },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        icon: 'group',
      },
    },
    {
      name: 'settings',
      displayName: 'menu.settings',
      meta: {
        icon: 'settings',
      },
    },
  ] as INavigationRoute[],
}
